"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function get() {
    return _Label.MARKING_TYPE;
  }
});
exports.Select = exports.STYLE_TYPE = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _Icon = require("b2b-components/theme/components/Icon");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
require("./Select.scss");
var STYLE_TYPE = /*#__PURE__*/function (STYLE_TYPE) {
  STYLE_TYPE["outlined"] = "outlined";
  STYLE_TYPE["underlined"] = "underlined";
  return STYLE_TYPE;
}(STYLE_TYPE || {});
exports.STYLE_TYPE = STYLE_TYPE;
var Select = function Select(_ref) {
  var autocomplete = _ref.autocomplete,
    className = _ref.className,
    onChange = _ref.onChange,
    options = _ref.options,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? null : _ref$info,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$markingType = _ref.markingType,
    markingType = _ref$markingType === void 0 ? _Label.MARKING_TYPE.none : _ref$markingType,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? STYLE_TYPE.outlined : _ref$styleType,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)'
    } : _ref$text,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value;
  var Error = Select.Error,
    Info = Select.Info,
    Label = Select.Label;
  var id = (0, _key.generateUnique)();
  var rootClassName = (0, _classnames["default"])('cds-Form-Input', "cds-Form-Input--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType)), {
    'cds-Form-Input--Error': error
  }, className);
  var placeholderOption;
  if (text.placeholder) {
    placeholderOption = /*#__PURE__*/_react["default"].createElement("option", {
      disabled: true,
      value: "",
      key: "placeholder"
    }, text.placeholder);
  }
  var selectOptions = [placeholderOption].concat((0, _toConsumableArray2["default"])(options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: option.value,
      key: option.value
    }, option.label);
  })));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react["default"].createElement(Label, {
    markingType: markingType,
    text: text,
    className: "cds-Form-Label cds-Select-Label",
    htmlFor: id
  }, text.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Select"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    autoComplete: autocomplete,
    className: "cds-Select-Input",
    disabled: isDisabled,
    id: id,
    onChange: onChange,
    value: value
  }, selectOptions), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-Select-Icon",
    name: _Icon.ICON_NAME.arrowDown
  }))), error && /*#__PURE__*/_react["default"].createElement(Error, null, error), info && /*#__PURE__*/_react["default"].createElement(Info, null, info));
};
exports.Select = Select;
Select.Error = _Error.Error;
Select.Info = _Info.Info;
Select.Label = _Label.Label;
Select.config = {
  markingType: _Label.MARKING_TYPE,
  styleType: STYLE_TYPE
};